var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.848 14.6432C10.4563 15.2699 9.54367 15.2699 9.152 14.6432L1.98339 3.17342C1.44076 2.30521 2.3986 1.27926 3.30198 1.76107L9.52934 5.08235C9.82345 5.23921 10.1764 5.23922 10.4705 5.08235L16.6981 1.76102C17.6014 1.27923 18.5593 2.30518 18.0166 3.17338L10.848 14.6432Z",
    fill: "#F7FDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletDown);
export default __webpack_public_path__ + "static/media/bullet-down.2e85881aa7a399750063e313c7de2c28.svg";
export { ForwardRef as ReactComponent };